export const getAncestorOrigin = () => {
  if (window.location.hash.includes('redirect_url')) return window.location.hash
  return null
}
